import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Terms of Service
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. Acceptance of Terms
        </Typography>
        <Typography paragraph>
          By accessing and using the NFT Art Engine platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Payment Terms
        </Typography>
        <Typography paragraph>
          All payments must be made in ETH on the Base network. Payments are final and non-refundable. The platform is not responsible for any transaction errors or network issues.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Intellectual Property Rights
        </Typography>
        <Typography paragraph>
          The NFTs generated using our platform are the sole property of the user who created them. NFT Art Engine does not claim any ownership rights over the generated content. Users are responsible for ensuring they have the necessary rights to use any uploaded content.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. User Responsibilities
        </Typography>
        <Typography paragraph>
          Users are solely responsible for:
          <ul>
            <li>The content they upload and generate</li>
            <li>Ensuring their content complies with applicable laws and regulations</li>
            <li>Any use or distribution of the generated NFTs</li>
          </ul>
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Limitation of Liability
        </Typography>
        <Typography paragraph>
          NFT Art Engine is not responsible for:
          <ul>
            <li>Any inappropriate content generated by users</li>
            <li>How users utilize the generated NFTs</li>
            <li>Any losses or damages resulting from the use of our platform</li>
            <li>Network issues or transaction failures on the Base network</li>
          </ul>
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Contact Information
        </Typography>
        <Typography paragraph>
          For any questions regarding these Terms of Service, please contact us at: <Link href="mailto:nftartengine@gmail.com">nftartengine@gmail.com</Link>
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Governing Law
        </Typography>
        <Typography paragraph>
          These Terms of Service shall be governed by and construed in accordance with the laws of France. Any disputes shall be subject to the exclusive jurisdiction of the courts of France.
        </Typography>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate(-1)}
            sx={{ textDecoration: 'none' }}
          >
            Back to Previous Page
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService; 